/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Start_L1Inputs */

const en_wc_tut_start_l1 = /** @type {(inputs: Wc_Tut_Start_L1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick Blank document to start from scratch, or a template such as Letter, Résumé, Report or the Studio handbook sample.`)
};

/**
* | output |
* | --- |
* | "Pick Blank document to start from scratch, or a template such as Letter, Résumé, Report or the Studio handbook sample." |
*
* @param {Wc_Tut_Start_L1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_start_l1 = /** @type {((inputs?: Wc_Tut_Start_L1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Start_L1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_start_l1(inputs)
});
export { wc_tut_start_l1 as "wc.tut.start.l1" }